
export const TOOLTIP_POSITIONS = {
    TOP_START: "b2b-lib-start_top",
    TOP_MIDDLE: "b2b-lib-centre_top",
    TOP_END: "b2b-lib-end_top",
    BOTTOM_START: "b2b-lib-start",
    BOTTOM_MIDDLE: "b2b-lib-centre_bottom",
    BOTTOM_END: "b2b-lib-end_bottom",
    LEFT_START: "b2b-lib-start_left",
    LEFT_MIDDLE: "b2b-lib-centre_left",
    LEFT_END: "b2b-lib-end_left",
    RIGHT_START: "b2b-lib-start_right",
    RIGHT_MIDDLE: "b2b-lib-centre_right",
    RIGHT_END: "b2b-lib-end_right",
};